// src/features/index.js

const features = {
  upworkIntegration: true,
  // add other features here
};

export default features;